/**
 * Product gallery: load the photos next to the one on screen.
 *
 * Only the first photo loads with the page; the others are marked loading="lazy". A lazy photo
 * inside a swipeable strip would otherwise start loading only at the moment it slides into
 * view, which leaves a blank frame for an instant. This watches the strip and switches the
 * photos within two slides of the visible one to eager, so swiping and the thumbnails feel
 * instant while the photos further away still cost nothing until someone heads for them.
 */
const REACH = '0px 150% 0px 150%'; // reaches the two slides on either side of the visible one

for (const strip of document.querySelectorAll('media-gallery slideshow-slides')) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        for (const image of entry.target.querySelectorAll('img[loading="lazy"]')) image.loading = 'eager';
      }
    },
    { root: strip, rootMargin: REACH }
  );

  for (const slide of strip.children) observer.observe(slide);
}
